module.exports = __webpack_public_path__ + "img/home_pic_3.5_5.ed7bc715.webp";